<template>
    <div class="page">
        <ui-header :sidebar="false" />

        <ui-breadcrumbs>
            <template #left>
                <slot name="bradcrumbs" />
            </template>
        </ui-breadcrumbs>

        <div class="layout" :class="[leftSidebarClass, rightSidebarClass]">
            <div class="layout-container">
                <div class="layout-page-left">
                    <transition name="layout-sidebar-left" mode="in-out">
                        <div v-show="leftSidebar" class="layout-sidebar layout-sidebar-left">
                            <slot
                                :show="showLeftSidebar"
                                :hide="hideLeftSidebar"
                                :toggle="toggleLeftSidebar"
                                name="sidebar-left"
                            />
                        </div>
                    </transition>
                </div>

                <div class="layout-header">
                    <div class="layout-header-top">
                        <slot name="header">
                            <div class="layout-header-left">
                                <slot name="header-left">
                                    <!--
										Estas são as classes usadas para titulo e subtitulo
										<div class="title">Titulo da página</div>
										<div class="subtitle">Subtitulo da página</div>
									-->
                                </slot>
                            </div>
                            <div class="layout-header-center">
                                <slot name="header-center" />
                            </div>
                            <div class="layout-header-right">
                                <slot name="header-right" />
                            </div>
                        </slot>
                    </div>

                    <div class="layout-header-content">
                        <div class="layout-content">
                            <slot name="content" />
                        </div>
                    </div>
                </div>
            </div>

            <transition name="overlay" mode="in-out">
                <div v-show="rightSidebar" class="overlay" @click.self="hideRightSidebar" />
            </transition>

            <transition name="layout-sidebar-right" mode="in-out">
                <div v-show="rightSidebar" class="layout-sidebar layout-sidebar-right">
                    <slot
                        :show="showRightSidebar"
                        :hide="hideRightSidebar"
                        :toggle="toggleRightSidebar"
                        name="sidebar-right"
                    />
                </div>
            </transition>
        </div>
        <ui-feedback-modal />
        <ui-thank-feedback-modal />
        <uiRatingNPS />
    </div>
</template>

<script>
	import uiHeader from '@/components/ui/panel-header'
	import { uiBreadcrumbs } from '@/components/ui'
	import uiFeedbackModal from '@/components/ui-facilita/modals/feedback-modal'
	import uiThankFeedbackModal from '@/components/ui-facilita/modals/feedback-modal/thank-feedback-modal'
	import { storage } from '@/services/storage'
	import uiRatingNPS from '@/components/ui-facilita/rating/nps/index.vue'

	export default {
		name: 'template-two-sidebars',

		components: {
			uiHeader,
			uiBreadcrumbs,
			uiRatingNPS,
			uiFeedbackModal,
			uiThankFeedbackModal
		},

		data() {
			return {
				leftSidebar: false,
				rightSidebar: false,
			}
		},

		computed: {
			leftSidebarClass() {
				return this.leftSidebar ? 'has-left-sidebar' : ''
			},
			rightSidebarClass() {
				return this.rightSidebar ? 'has-right-sidebar' : ''
			},
		},

		beforeMount() {
            this.$nextTick(() => {
				const companiesRestricted = this.$store.getters.companiesRestricted
				let user = JSON.parse(storage.get('user_logged'))
				let config = JSON.parse(storage.get('api_config'))

				window.dataLayer[0].user 				 = user
				window.dataLayer[0].configs 			 = JSON.parse(storage.get('get-configs-data'))
				window.dataLayer[0].companies_restricted = companiesRestricted
				window.dataLayer[0].instance_user_id 	 = config.instance + '_' + user.id
				window.dataLayer[0].instance 	 		 = config.instance
            })
        },

		methods: {
			/**
			 * Métodos para mostrar e esconder o sidebar da ESQUERDA
			 * Os métodos são entregues via SLOT
			 * <template #sidebar-left="{ show, hide, toggle }">
			 *      <button @click="show">usado para ocultar o sidebar</button>
			 *      <button @click="hide">usado para mostrar o sidebar</button>
			 *      <button @click="toggle">usado para inverter o estado do sidebar</button>
			 *  </template>
			 */
			showLeftSidebar() {
				this.leftSidebar = true
			},
			hideLeftSidebar() {
				this.leftSidebar = false
			},
			toggleLeftSidebar() {
				this.leftSidebar = !this.leftSidebar
			},

			/**
			 * Métodos para mostrar e esconder o sidebar da DIREITA
			 * Os métodos são entregues via SLOT
			 * <template #sidebar-right="{ show, hide, toggle }">
			 *      <button @click="show">usado para ocultar o sidebar</button>
			 *      <button @click="hide">usado para mostrar o sidebar</button>
			 *      <button @click="toggle">usado para inverter o estado do sidebar</button>
			 *  </template>
			 */
			showRightSidebar() {
				this.rightSidebar = true
			},
			hideRightSidebar() {
				this.rightSidebar = false
			},
			toggleRightSidebar() {
				this.rightSidebar = !this.rightSidebar
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
